import { Breadcrumb } from '@chakra-ui/react';
import { Fragment } from 'react';
import { Link } from 'react-router';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

function BreadcrumbComponent({ items }: BreadcrumbProps) {
  return (
    <Breadcrumb.Root>
      <Breadcrumb.List>
        {items.map((item, index) => (
          <Fragment key={`breadcrumb-${index}-${item.label}`}>
            <Breadcrumb.Item>
              {item.href ? (
                <Breadcrumb.Link asChild>
                  <Link to={item.href}>{item.label}</Link>
                </Breadcrumb.Link>
              ) : (
                <Breadcrumb.CurrentLink>{item.label}</Breadcrumb.CurrentLink>
              )}
            </Breadcrumb.Item>
            {index < items.length - 1 && <Breadcrumb.Separator />}
          </Fragment>
        ))}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  );
}

export default BreadcrumbComponent;
